import React, { useEffect, useState } from "react";
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Container,
    Paper,
    Typography
} from "@mui/material";
import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const stripHtml = (value) => String(value || "").replace(/<[^>]*>/g, "").trim();

const UnsubscribePage = () => {
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const token = searchParams.get("token");

        const run = async () => {
            if (!token) {
                setIsSuccess(false);
                setMessage("Unsubscribe failed: missing token.");
                setIsLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `${API_BASE}/messages/unsubscribe?token=${encodeURIComponent(token)}`
                );
                const responseText = await response.text();
                setIsSuccess(response.ok);
                setMessage(stripHtml(responseText) || (response.ok ? "You have been unsubscribed successfully." : "Unsubscribe failed."));
            } catch (error) {
                setIsSuccess(false);
                setMessage("Unsubscribe failed due to network error. Please try again later.");
            } finally {
                setIsLoading(false);
            }
        };

        void run();
    }, [searchParams]);

    return (
        <Container maxWidth="sm" sx={{ my: 5 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                {isLoading ? (
                    <Box sx={{ textAlign: "center", py: 2 }}>
                        <CircularProgress size={52} sx={{ mb: 2 }} />
                        <Typography variant="h6">Processing unsubscribe...</Typography>
                    </Box>
                ) : (
                    <Box sx={{ textAlign: "center" }}>
                        {isSuccess ? (
                            <CheckCircleOutline color="success" sx={{ fontSize: 64, mb: 1 }} />
                        ) : (
                            <ErrorOutline color="error" sx={{ fontSize: 64, mb: 1 }} />
                        )}
                        <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
                            {isSuccess ? "Unsubscribed" : "Unsubscribe error"}
                        </Typography>
                        <Alert severity={isSuccess ? "success" : "error"} sx={{ mb: 3, textAlign: "left" }}>
                            {message}
                        </Alert>
                        <Button variant="contained" href="/">
                            Back to homepage
                        </Button>
                    </Box>
                )}
            </Paper>
        </Container>
    );
};

export default UnsubscribePage;
